import {
  validateMaxLength,
  validateMinLength,
  validatePassword,
  validateRequired,
} from "../helpers/Validation";
const ValidateResetPassword = (setError, newPassword) => {
  let valid = true;
  let isPasswordValid = true;

  //validate old_password if exist
  if (newPassword.old_password || newPassword.old_password == "") {
    if (!validateRequired(newPassword.old_password)) {
      valid = false;
      setError("old_password", "يجب إدخال كلمة المرور الحالية");
      // } else if (newPassword.old_password.length < 8) {
      //     valid = false;
      //     setError('old_password', 'لا يجب أن تقل كلمة المرور عن 8 حروف');
      // } else if (newPassword.old_password.length > 10) {
      //     valid = false;
      //     setError('old_password', 'لا يجب أن تزيد كلمة المرور عن 10 حروف');
    } else {
      setError("old_password");
    }
  }
  //validate password
  if (!validateRequired(newPassword.password)) {
    valid = false;
    isPasswordValid = false;
    setError("password", "يجب إدخال كلمة المرور الجديدة");
  } else if (!validateMaxLength(newPassword.password, 10)) {
    valid = false;
    isPasswordValid = false;
    setError(
      "password",
      "كلمه السر يجب أن تحتوي ع حرف كبير وحرف صغير و رقم ولا يقل عن 8 حروف ولا يزيد عن 10 حروف",
    );
  } else if (validateMinLength(newPassword.password, 8)) {
    valid = false;
    isPasswordValid = false;
    setError(
      "password",
      "كلمه السر يجب أن تحتوي ع حرف كبير وحرف صغير و رقم ولا يقل عن 8 حروف ولا يزيد عن 10 حروف",
    );
  } else if (!validatePassword(newPassword.password)) {
    valid = false;
    isPasswordValid = false;
    setError(
      "password",
      "كلمه السر يجب أن تحتوي ع حرف كبير وحرف صغير و رقم ولا يقل عن 8 حروف ولا يزيد عن 10 حروف",
    );
  } else {
    setError("password");
  }

  //validate confirm_password
  if (isPasswordValid) {
    setError("confirm_password");
  } else if (!validateRequired(newPassword.confirm_password)) {
    valid = false;
    setError("confirm_password", "يجب تأكيد كلمة المرور الجديدة");
  } else if (newPassword.password != newPassword.confirm_password) {
    valid = false;
    setError("confirm_password", "يجب أن تطابق مع كلمة المرور الجديدة");
  } else {
    setError("confirm_password");
  }

  return valid;
};
export default ValidateResetPassword;
